<template>
  <r-button
    size="16px"
    color="primary"
    textColor="riseup-beige"
    padding="12px"
    :class="{'flip-horizontal': flipIcon}"
    :icon="icon"
    round
    unelevated
    v-on="$listeners"
  />
</template>

<script>
import RButton from '@/components/base/RButton';

export default {
  name: 'RoundButton',
  components: { RButton },
  props: {
    icon: {
      type: String,
      required: true,
    },
    flipIcon: Boolean,
  },
};
</script>
